import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-C3S40LQHFD'; 

/**
 * This component tracks page views for a Single Page Application.
 * It sends a page_view event to Google Analytics whenever the route changes.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const getPageTitle = (pathname) => {
      switch (pathname) {
        case '/':
          return 'Asha AI - Home';
        case '/login':
          return 'Asha AI - Login';
        case '/register':
          return 'Asha AI - Register';
        case '/join-waitlist':
          return 'Asha AI - Join Waitlist';
        default:
          if (pathname.startsWith('/patient-dashboard')) {
            return 'Asha AI - Patient Dashboard';
          }
          if (pathname.startsWith('/health-priorities')) {
            return 'Asha AI - Health Priorities';
          }
          // Fallback for other routes
          return 'Asha AI - Other';
      }
    };
    
    const title = getPageTitle(location.pathname);
    document.title = title;

    // This effect fires on component mount and whenever the location changes.
    // This ensures that the initial page load is tracked, as well as all
    // subsequent navigation events in the SPA.
    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: title,
      });
    }
  }, [location]);

  return null; // This component does not render anything to the DOM.
};

export default AnalyticsTracker; 